// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
const loadImages = require("%helpers%/load-images.js");
// -- Helpers END


// -- Libraries BEGIN
import swiper from "swiper";
// -- Libraries END


windowLoad(function() {

	const sliderData = {
		element: $(".news-content-small-slider .swiper-container"),
		arrows: {
			all: $(".news-content-small-slider .slider-arrows__arrow"),
			prev: $(".news-content-small-slider .slider-arrows__arrow_prev"),
			next: $(".news-content-small-slider .slider-arrows__arrow_next"),
		},
	};

	const swiperData = {
		spaceBetween: 20,
		speed: 600,
		loop: false,
		slidesPerView: 1,
		autoHeight: true,
		navigation: {
			prevEl: sliderData.arrows.prev,
			nextEl: sliderData.arrows.next,
		},
	};

	// -- Functions BEGIN
	const sliderInit = () => {
		new swiper(sliderData.element, swiperData);
	};
	// -- Functions END


	if (sliderData.element.length) sliderInit();

});

